import styled from 'styled-components'

import { StyledBoxedImage } from '@/molecules/BoxedImage/styles'
import styledMap from 'styled-map'
import { StyledDefaultSliderNavigation, StyledDefaultSliderNavigationButton } from '@/molecules/Sliders/styles'

export const StyledTabFilterTitle = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: flex-start;
  padding: ${({ theme }) =>theme.rem(16)};

  > span{
    white-space: nowrap;
    ${({ theme }) => theme.mediaQuery.md(`
      display: block;
      white-space: normal;
      width: 50%;
    `)}
  }

  ${({ theme }) => theme.mediaQuery.md(`
    position: absolute;
    left: 0;
    bottom: 0;
    z-index: 2;
    width: 100%;
    height: ${theme.rem(55)};
  `)}
`

export const StyledTabFilter = styled.div`
  cursor: pointer;
  flex-shrink: 0;
  width: auto;

  --size: ${styledMap`
    default: 240px;
    small: 130px;
  `};

  ${({ theme, hideImg }) => theme.mediaQuery.md(`
    width: var(--size);
    height: ${hideImg ? theme.rem(180) : 'auto'};
  `)}

  ${StyledBoxedImage}{
    display: block;
    height: 100%;
    position: relative;
    max-height: 80px;
    transition: border-color ease-in-out .4s;
    border-radius: ${({ theme }) => theme.rem(8)};
    border: 1px solid ${({ theme }) => theme.colors.grayscale.gray200};
    aspect-ratio: ${styledMap('hideImg', { default: 'auto', false: '16 / 9' })};
    &:hover{
      border-color: ${({ theme }) => theme.colors.general.light()};

      ${({ theme, current }) => !current && theme.mediaQuery.md(`
        border-color: ${theme.colors.grayscale.gray200};
      `)}
    }

    ${({ theme, current }) => current && `border-color: ${theme.colors.general.light()};`}

    ${({ theme }) => theme.mediaQuery.md(`
      border-radius: ${theme.rem(16)};
      aspect-ratio: 16 / 9;
      max-height: 100%;
    `)}

    img{
      height: ${({ theme, hideImg }) => hideImg ? theme.rem(125) : 'auto'};
      position: relative;
      z-index: 0;
      display: ${styledMap('hideImg', { default: 'none', false: 'block', })};

      ${({ theme }) => theme.mediaQuery.md(`
        display: block;
      `)}
    }
  }

  ${StyledTabFilterTitle}{
    transition: text-decoration ease-in-out .6s;
    color: ${({ theme }) => theme.colors.general.light()};

    ${({ theme, current }) => current && `
      color: ${theme.colors.grayscale.white};
      background: ${theme.colors.general.light()};
      
      ${theme.mediaQuery.md(`
        text-decoration: underline;
      `)}
    `}

    ${({ theme, current }) => !current && theme.mediaQuery.md(`
      color: ${theme.colors.grayscale.white};
      background: ${theme.colors.general.light()} ;

      &:hover{
        border-color: ${theme.colors.general.light()};
        
        ${theme.mediaQuery.md(`
          text-decoration: underline;
        `)}
      }
    `)}

    ${({ theme, current }) => current && theme.mediaQuery.md(`
      height: 100%;
    `)}
  }
`
export const StyledTabFilterList = styled.div`
  .swiper{
    ${({ theme }) => theme.paddingX(48)};
  }

  ${({ theme }) => theme.mediaQuery.md(`
    .swiper{
      --col-min: calc(1 / 12 * 100vw);
      --col: calc((100vw - var(--max-width)) / 2);
      padding-left: clamp(var(--col-min),var(--col),var(--col));
      padding-right: clamp(var(--col-min),var(--col),var(--col));
    }
  `)}

  .swiper-slide{
    width: fit-content;
  }
`

export const StyledTabFilterNavigation = styled(StyledDefaultSliderNavigation)`
  justify-content: space-between;
  bottom: unset;
  top: 50%;
  transform: translateY(-50%);
  padding: 0;

  ${({ theme }) => theme.mediaQuery.md(`
    padding: 0 ${theme.rem(10)};
  `)}

  ${({ theme }) => theme.mediaQuery.lg(`
    display: none;
  `)}
`

export const StyledTabFilterNavigationButton = styled(StyledDefaultSliderNavigationButton)``
